const red200Color = '#E9A5A5';

export default red200Color;
